module.exports = __webpack_public_path__ + "img/normal_multiplier_5.323c4709.png";